import { BffDataAU, ListingServiceAU as ListingService, ListingServiceAUV2} from "../../../service";
import Types from "./types";
import { updateAppliedFilters} from "../filters/actions";
import { resetCityLocation } from "../location-picker-popup/actions";
import { FINANCE_TYPE } from "../../../constants/checkout-constants";
import { ZERO_DP_VARIANTS } from "../../../constants/optimize-constants";
import { API_SOURCE } from "../../../constants/app-constants";
import { STATE_CODES } from "../../../constants/state-name-constants";
import getMeaningfulExperimentNames from "../../../utils/statsig-ab-utils/get-meaningful-experiment-names";
import { STATE_EXPERIMENT_MAP } from "../../../../server/utils/get-listing-sorting-experiment-data";

const fetchCarListInit = () => ({
    type: Types.FETCH_CAR_LIST
});

const fetchCarListSuccess = (data, params) => ({
    type: Types.FETCH_CAR_LIST_SUCCESS,
    data,
    params
});

const fetchSimilarCarSuccess = (data, params) => ({
    type: Types.FETCH_SIMILAR_CAR_LIST_SUCCESS,
    data,
    params
});

const fetchCarListFailure = (error) => ({ type: Types.FETCH_CAR_LIST_FAILURE, error });

const fetchCarList = (params, queryString) => (dispatch, getState) => {
    dispatch(fetchCarListInit());
    const {
        user: { secureToken, isUserZeroDpVariant, isGuestLogin, userGeoData = {} },
        abExperiment = {}
    } = getState();

    // Get sortingVariant from AB experiment
    const {state: {isoCode = STATE_CODES.VIC} = {}} = userGeoData || {};
    const experimentKey = STATE_EXPERIMENT_MAP[isoCode || STATE_CODES.VIC]?.[API_SOURCE.WEB_APP];
    const sortingReducerKey = getMeaningfulExperimentNames(experimentKey);
    const { [sortingReducerKey]: {data: sortingVariant} = {}} = abExperiment || {};

    let cityObj = null;
    params = {...params, zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP };
    if (queryString && queryString.indexOf("userFinanceType") < 0) {
        queryString = `${queryString}&userFinanceType=${FINANCE_TYPE.CARS24}`;
    }
    return new Promise((resolve, reject) => {
        ListingService.fetchListing(params, queryString, isGuestLogin ? null : secureToken, userGeoData, sortingVariant)
            .then(response => {
                dispatch(fetchCarListSuccess(response.data, params));
                dispatch(updateAppliedFilters(response.data.facets));
                if (response.data.metaContent.cityInfo) {
                    cityObj = {
                        id: response.data.metaContent.cityInfo.id,
                        name: response.data.metaContent.cityInfo.name,
                        code: response.data.metaContent.cityInfo.code
                    };
                } else {
                    cityObj = {};
                }
                dispatch(resetCityLocation(cityObj));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchCarListFailure(error));
                reject(error);
            });
    });
};

const fetchCarListV2 = (params, queryString, sortingVariant) => (dispatch, getState) => {
    dispatch(fetchCarListInit());
    const {
        user: { secureToken, isUserZeroDpVariant, isGuestLogin, userGeoData }
    } = getState();
    let cityObj = null;
    params = {...params, zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP };
    if (queryString && queryString.indexOf("userFinanceType") < 0) {
        queryString = `${queryString}&userFinanceType=${FINANCE_TYPE.CARS24}`;
    }
    return new Promise((resolve, reject) => {
        ListingServiceAUV2.fetchListingV2(params, queryString, isGuestLogin ? null : secureToken, userGeoData, sortingVariant)
            .then(response => {
                dispatch(fetchCarListSuccess(response.data, params));
                dispatch(updateAppliedFilters(response.data.facets));
                if (response.data.metaContent.cityInfo) {
                    cityObj = {
                        id: response.data.metaContent.cityInfo.id,
                        name: response.data.metaContent.cityInfo.name,
                        code: response.data.metaContent.cityInfo.code
                    };
                } else {
                    cityObj = {};
                }
                dispatch(resetCityLocation(cityObj));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchCarListFailure(error));
                reject(error);
            });
    });
};

const fetchSimilarCarListInit = () => ({
    type: Types.FETCH_SIMILAR_CAR_LIST
});
const fetchSimilarCarListFailure = (error) => ({ type: Types.FETCH_SIMILAR_CAR_LIST_FAILURE, error });

const fetchSimilarCarListV2 = (params, queryString, sortingVariant) => (dispatch, getState) => {
    dispatch(fetchSimilarCarListInit());
    const {
        user: { secureToken, isUserZeroDpVariant, isGuestLogin, userGeoData }
    } = getState();
    if (queryString && queryString.indexOf("userFinanceType") < 0) {
        const userFinanceType = FINANCE_TYPE.CARS24;
        queryString = `${queryString}&userFinanceType=${userFinanceType}`;
    }
    let cityObj = null;
    params = {zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP, ...params};
    return new Promise((resolve, reject) => {
        ListingServiceAUV2.fetchListingV2(params, queryString, isGuestLogin ? null : secureToken, userGeoData, sortingVariant)
            .then((response) => {
                dispatch(fetchSimilarCarSuccess(response.data, params));
                dispatch(updateAppliedFilters(response.data.facets));
                if (response.data.metaContent.cityInfo) {
                    cityObj = {
                        id: response.data.metaContent.cityInfo.id,
                        name: response.data.metaContent.cityInfo.name,
                        code: response.data.metaContent.cityInfo.code
                    };
                } else {
                    cityObj = {};
                }
                dispatch(resetCityLocation(cityObj));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchSimilarCarListFailure({error}));
                reject(error);
            });
    });
};

const updateSSRStatus = (isSSR) => ({
    type: Types.UPDATE_SSR_STATUS,
    isSSR
});

const resetCarList = ()  => ({
    type: Types.RESET_CAR_LIST
});

const reloadCarList = (shouldReloadList) => ({
    type: Types.RELOAD_CAR_LIST,
    shouldReloadList
});

// Fetch FAQ Data
const fetchClpDataInit = () => ({
    type: Types.FETCH_FAQ_DATA
});

const fetchClpDataSuccess = (data, params) => ({
    type: Types.FETCH_FAQ_DATA_SUCCESS,
    data,
    params
});

const fetchClpDataFailure = (error) => ({ type: Types.FETCH_FAQ_DATA_FAILURE, error });

const fetchClpData = (params, queryString) => (dispatch, getState) => {
    dispatch(fetchClpDataInit());
    const {
        user: { secureToken, isUserZeroDpVariant, isGuestLogin }
    } = getState();
    params = {...params, zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP };

    return new Promise((resolve, reject) => {
        ListingService.fetchClpData(params, queryString, isGuestLogin ? null : secureToken)
            .then(response => {
                dispatch(fetchClpDataSuccess(response.data, params));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchClpDataFailure(error));
                reject(error);
            });
    });
};

const cmsConfigInit = () => ({
    type: Types.CMS_CONFIG_INIT
});

const cmsConfigSuccess = (data) => ({
    type: Types.CMS_CONFIG_SUCCESS,
    data
});

const cmsConfigFailure = (error) => ({
    type: Types.CMS_CONFIG_FAILURE,
    error
});

const fetchCmsConfig = (params) => async (dispatch) => {
    dispatch(cmsConfigInit());
    try {
        const response = await BffDataAU.getCmsContent(params);
        dispatch(cmsConfigSuccess(response.data));
    } catch (error) {
        dispatch(cmsConfigFailure(error));
    }
};

const updateClassifiedHandpickedBannerState = (state) => ({
    type: Types.UPDATE_CLASSIFIED_HANDPICKED_BANNER_STATE,
    state
});

const fetchCarouselDataSuccess = (data, params) => ({
    type: Types.FETCH_CAROUSEL_DATA_SUCCESS,
    data,
    params
});

const fetchCarouselDataFailure = (error) => ({
    type: Types.FETCH_CAROUSEL_DATA_FAILURE,
    error
});
const fetchCarouselDataInit = () => ({
    type: Types.FETCH_CAROUSEL_DATA
});

const fetchCarouselData = (params) => async (dispatch, getState) => {
    dispatch(fetchCarouselDataInit());
    const {
        user: { secureToken }
    } = getState();
    try {
        const response = await BffDataAU.getCarouselData(params, secureToken);
        dispatch(fetchCarouselDataSuccess(response.data, params));
        return response.data;
    } catch (error) {
        dispatch(fetchCarouselDataFailure(error));
        return error;
    }
};

const fetchSEODataInit = () => ({
    type: Types.FETCH_SEO_DATA
});

const fetchSEODataSuccess = (data) => ({
    type: Types.FETCH_SEO_DATA_SUCCESS,
    data
});

const fetchSEODataFailure = (error) => ({
    type: Types.FETCH_SEO_DATA_FAILURE,
    error
});

const fetchSEOData = ({listingPath, payload, sortingVariant = ""}) => async (dispatch, getState) => {
    const {
        user: { userGeoData = {} }
    } = getState();
    dispatch(fetchSEODataInit());
    try {
        const lowerCaseListingPath = listingPath ? listingPath.toLowerCase() : listingPath;
        const params = {"spath": lowerCaseListingPath };
        const response = await BffDataAU.getSEOData({params, payload, userGeoData, sortingVariant});
        dispatch(fetchSEODataSuccess(response.data));
        return response.data;
    } catch (error) {
        dispatch(fetchSEODataFailure(error));
        throw error;
    }
};

export {
    fetchCarList,
    fetchCarListV2,
    fetchSimilarCarListV2,
    updateSSRStatus,
    resetCarList,
    reloadCarList,
    fetchClpData,
    fetchCmsConfig,
    updateClassifiedHandpickedBannerState,
    fetchCarouselData,
    fetchSEOData
};
